import { Typography } from "@mui/material";
import FetcherSettingsTable from "./FetcherSettingsTable";

const tableHeadings = {
  raw_output_table_name: "Raw Output Table",
  config_name: "Config Name",
  report_name: "Report Name",
  format_type: "Format Type",
  collection_method_name: "Collection Method",
  collection_type_name: "Collection Type",
  sub_filtering_method_name: "Supports Filtering Based on",
};

const FetcherSettings = () => {
  // const [searchParams] = useSearchParams();
  // const brandIdFromURL = searchParams.get("brand_id") || "";
  // const dispatch = useDispatch();

  // // Dynamically reads which tab is active from URL
  // const reportType = searchParams.get("report") || "daily_user";

  // // Separate ref just for fetcher — independent from fetchedTabs in Redux
  // //const fetchedFetcherRef = useRef<Set<string>>(new Set());

  // const fetchedTabs = useSelector(
  //   (state: any) => state.brandConfigurationReport.fetchedTabs,
  // );

  // const brandOverviewUnifierSettingsData = useSelector(
  //   (state: any) =>
  //     state.brandConfigurationReport.brandOverviewUnifierSettingsData[
  //       reportType
  //     ],
  // );

  // const { fetchFetcherSettings } = useBrandConfigOverview();

  // // 1st :  Extract unique raw_table_id values
  // const rawTableIds = useMemo(() => {
  //   if (
  //     !brandOverviewUnifierSettingsData ||
  //     brandOverviewUnifierSettingsData.length === 0
  //   )
  //     return [];
  //   return [
  //     ...new Set(
  //       brandOverviewUnifierSettingsData.map((item: any) =>
  //         String(item.raw_table_id),
  //       ),
  //     ),
  //   ];
  // }, [brandOverviewUnifierSettingsData]);

  // // 2nd: Fetch fetcher settings for each unique raw_table_id
  // useEffect(() => {
  //   if (rawTableIds && rawTableIds?.length === 0) return;
  //   //if (fetchedFetcherRef.current.has(reportType)) return;

  //   if (fetchedTabs[reportType]) return; // Guard: skip if already fully done

  //   const getFetcherSettingsForRawTableIds = async (rawTableIds: any[]) => {
  //     for (const rawTableId of rawTableIds) {
  //       await fetchFetcherSettings(brandIdFromURL, rawTableId);
  //     }
  //     //  setTabFetched dispatches  after all  fetches are done, to avoid multiple dispatches and re-renders
  //     dispatch(setFetchedTabs(reportType as any));
  //   };

  //   getFetcherSettingsForRawTableIds(rawTableIds);

  //   // eslint-disable-next-line
  // }, [rawTableIds]);

  return (
    <>
      <Typography px={2} py={1} variant="h6">
        Fetcher Settings
      </Typography>
      <FetcherSettingsTable tableHeadings={tableHeadings} />
    </>
  );
};

export default FetcherSettings;
